import { Component, OnInit } from '@angular/core';
import { KnownBusyScopes } from '@sw-processes/shared';
import { BusyService, IBusyService } from '@mosaik/presentation';
import { SurveyService } from '../../services/survey.service';
import { SurveyResult } from '../../models/survey-result.model';

@Component({
  selector: 'sw-processes-survey-result',
  templateUrl: './survey-result.component.html',
  styleUrls: ['./survey-result.component.scss']
})
export class SurveyResultComponent implements OnInit {
  private readonly _surveyService: SurveyService;
  private readonly _busyService: IBusyService;

  private _isLoading: boolean;
  private _isSuccessful: boolean;

  public constructor(surveyService: SurveyService, busyService: BusyService) {
    this._surveyService = surveyService;
    this._busyService = busyService;
    this._isLoading = false;
    this._isSuccessful = false;
  }

  public get isLoading(): boolean {
    return this._isLoading;
  }

  public get isSuccessful(): boolean {
    return this._isSuccessful;
  }

  public async ngOnInit(): Promise<void> {
    this._isLoading = true;
    const surveyResult = this.getUrlVarsAsSurveyResult();
    if (this.isSurveyResultValid(surveyResult)) {
      this._busyService.beginScope(KnownBusyScopes.presenter.header, () =>
        this._surveyService
          .survey(surveyResult)
          .then(() => {
            this._isLoading = false;
            this._isSuccessful = true;
          })
          .catch(() => {
            this._isLoading = false;
          })
      );
    } else {
      this._isLoading = false;
    }
  }

  private getUrlVarsAsSurveyResult(): SurveyResult {
    const vars = new SurveyResult();
    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (seperator, key, value) => {
      (vars as any)[key] = value;
      return value;
    });
    return vars;
  }

  private isSurveyResultValid(result: SurveyResult): boolean {
    return Object.keys(result).length > 0 && result.hash !== undefined && result.id !== undefined && result.result !== undefined;
  }
}
